export enum RegisterStatuses
{
    New = 1,
    Pending = 2,
    Published = 3,
    GenerationInProgress = 4,
    GenerationComplete = 5
}